import React, { useState, useEffect } from 'react';
import { getSignature } from '../../utils/wxShare';
import './index.scss';

const Page1: React.FC = () => {

	useEffect(() => {
		getSignature();
	}, []);

	return <section className="page page1">
		<video src='./audio/video.mp4' controls autoPlay />
	</section>
}

export default Page1;
